<template>
  <navbar></navbar>
  <div class="main-container">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import navbar from "@/components/NavbarTemp.vue";
export default {
  components: {
    navbar,
  },
};
</script>
